/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import Button from "../../shared/button";
import styles from "./styles.css";
import iconImg from "./images/infoicon.svg";
import gotitImg from "./images/gotit.svg";
import CloseIcon from "./images/closeicon.svg";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const CarReservationNotifyModal = ({
    cta,
    isOpen,
    notifyIconCliked,
    onWishlistClick,
    handleCarReservationModal,
    wishlistActionCompleted
}) => {
    const getData = () => {
        let header = "";
        let icon = ""; //importedIcon
        let subHeader = "";
        let singleButton = true;
        let btn1Cta = "";
        let btn2Cta = "";
        let btn1Action = () => {};
        let btn2Action = () => {};
        if (notifyIconCliked) {
            header = "This car is currently reserved";
            icon = iconImg; //importedIcon
            subHeader = "You can choose to be notified if this car becomes available to purchase in the near future";
            singleButton = true;
            btn1Cta = "NOTIFY ME";
            btn2Cta = "";
            btn1Action = (e) => {
                const showNotifyPopup = true;
                onWishlistClick(e, "", showNotifyPopup);
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_TOOLTIP_POPUP, {
                    eventLabel: "notify_me"
                });
            };
            btn2Action = () => {};
        }  else if (wishlistActionCompleted) {
            header = "We will notify you";
            icon = gotitImg; //importedIcon
            subHeader = "You will be notified if the car becomes available. We have also added this car to your wishlist";
            singleButton = true;
            btn1Cta = "GOT IT";
            btn2Cta = "";
            btn1Action = () => {
                handleCarReservationModal();
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME, {
                    eventLabel: "got_it"
                });
            };
            btn2Action = () => {};
        } else if (cta.key === "removedReservationNofication") {
            header = "Are you sure?";
            icon = "";
            subHeader = "Removing this car from your wishlist means we’ll not be able to notify you if it becomes available";
            singleButton = false;
            btn1Cta = "REMOVE";
            btn2Cta = "KEEP";
            btn1Action = (e) => {
                onWishlistClick(e);
                handleCarReservationModal();
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST_POPUP, {
                    eventLabel: "remove"
                });
            };
            btn2Action = () => {
                handleCarReservationModal();
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST_POPUP, {
                    eventLabel: "keep"
                });
            };
        }
        return {
            header, icon, subHeader, singleButton, btn1Cta, btn2Cta, btn1Action, btn2Action
        };
    };
    const closePopUp = (e) => {
        if (notifyIconCliked) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_TOOLTIP_POPUP, {
                eventLabel: "cross"
            });
        } else if (wishlistActionCompleted) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME, {
                eventLabel: "cross"
            });
        } else if (cta.key === "removedReservationNofication") {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST_POPUP, {
                eventLabel: "cross"
            });
        }
        handleCarReservationModal(e);
    };
    const { header, icon, subHeader, singleButton, btn1Cta, btn2Cta, btn1Action, btn2Action } = getData();
    return (
        <Modal isOpen={isOpen} close={handleCarReservationModal}>
            <div styleName={"styles.overlay"}>
                <img styleName={"styles.close_icon"} src={CloseIcon} alt={CloseIcon} onClick={closePopUp} />
                {icon && <img styleName={"styles.info_icon"} src={icon} alt={icon} />}
                <h1>{header}</h1>
                <p>{subHeader}</p>
                {singleButton ? <div styleName={"styles.first_btn"}>
                    <Button text={btn1Cta} onClick={btn1Action}/>
                </div> :
                    <div styleName={"styles.car_reservation_btn"}>
                        <Button text={btn1Cta} onClick={btn1Action} />
                        <Button text={btn2Cta} onClick={btn2Action} />
                    </div>}
            </div>
        </Modal>
    );
};

CarReservationNotifyModal.propTypes = {
    isOpen: PropTypes.bool,
    cta: PropTypes.object,
    notifyIconCliked: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    handleCarReservationModal: PropTypes.func,
    wishlistActionCompleted: PropTypes.func
};
export default CarReservationNotifyModal;
